import React from "react";
import { Stack, Typography } from "@mui/material";
import {
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { useDetailSectionHeader } from "../../../../contexts/DetailSectionHeaderContext";

interface SurveySettingsTabContentHeaderProps {
  title: string;
}

export const SurveySettingsTabContentHeader: React.FC<
  SurveySettingsTabContentHeaderProps
> = ({ title }) => {
  const tokens = useFoundationColorTokens();
  const spacing = useSpacing();
  const typography = useTypography();
  const { detailSectionHeaderElement } = useDetailSectionHeader();

  const sectionHeaderHeight = detailSectionHeaderElement?.clientHeight ?? 0;

  return (
    <Stack
      borderBottom={`1px solid ${tokens.border}`}
      paddingBlock={spacing.spaceXL}
      position="sticky"
      top={sectionHeaderHeight}
      bgcolor={tokens.backgroundElevatedLevel1}
      zIndex={2}
    >
      <Typography color={tokens.label} sx={typography.sh1}>
        {title}
      </Typography>
    </Stack>
  );
};
